import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import { Login } from '@ui/pages/login';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from '../pages/login';
import Layout from '.';
import Proposals from '../pages/proposals';
import Chat from '../pages/chat';
import Users from '../pages/users';
import Companies from '../pages/companies';
import KnowledgeBase from '../pages/knowledgeBase';
// import { Layout } from '.';
const AppRoutes = () => {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: '/login', element: _jsx(Login, {}) }), _jsxs(Route, { element: _jsx(Layout, {}), children: [_jsx(Route, { path: '/proposal', element: _jsx(Proposals, {}) }), _jsx(Route, { path: '/chat', element: _jsx(Chat, {}) }), _jsx(Route, { path: '/users', element: _jsx(Users, {}) }), _jsx(Route, { path: '/company', element: _jsx(Companies, {}) }), _jsx(Route, { path: '/knowledgebase', element: _jsx(KnowledgeBase, {}) })] }), _jsx(Route, { path: '*', element: _jsx(Navigate, { to: `/login`, replace: true }) })] }));
};
export default AppRoutes;
